<template>
  <div class="supplier-manage">
    <banner clazz="supplier-manage-banner" url="supplier">
      <template slot="buttons">
        <el-button class="banner-button" round @click="this.goConsult">立即咨询</el-button>
        <el-button class="banner-button" round @click.native="goMore('gongyingshang-banner-tiyan')">申请体验</el-button>
      </template>
    </banner>
    <div class="supplier-manage-section1">
      <div class="clearfix section1-content">
        <img class="section1-img" src="../../assets/img/supplier/1section.png" alt="供应商管理"/>
        <div class="section1-misc">
          <h1 class="misc-title">供应商管理</h1>
          <div class="misc-divider"></div>
          <p class="misc-content">我们的供应商管理模块为您提供了一系列功能，使您能够提高供应商管理效率。通过供应商准入评审，对不同品类供应商多策略管控，引入征信信息，对供应商进行风险前置监控。绩效模块跟踪每个供应商绩效表现，助您实时掌控供应商动态。</p>
          <el-button class="consult-button" @click.native="goMore('gongyingshang-chanpin-yuyue')">预约演示
            <img src="../../assets/img/bidding/icon_demo.svg" alt="预约演示">
          </el-button>
        </div>
      </div>
    </div>
    <div class="supplier-manage-section2">
      <div class="section2-content">
        <h1 class="section2-title">360度洞察供应商</h1>
        <div class="section2-divider"></div>
        <p class="section2-detial">供应商管理模块，对供应商信息，绩效和关系的全面功能。通过直观且易于使用的供应商操作台，</p>
        <p class="section2-detial"> 您的供应商可随时检视自身绩效，获知业务改善点，您可以360度全面了解供应商绩效表现，增强业务掌控力。</p>
        <div class="section2-main">
          <div class="section2-choose">
            <ul class="section2-ul clearfix">
              <li class="section2-li fl" v-for="(item, index) in mainData" :key="index">
                <div class="detail">
                  <img class="detail-img" v-lazy="item.src" alt="360度洞察供应商">
                </div>
                <h2 class="detail-title"> {{item.title}} </h2>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="supplier-manage-section3">
      <div class="section3-content">
        <div class="section3-head">
          <h1 class="section3-title">您用供应商管理系统能做什么？</h1>
          <div class="section3-divider"></div>
        </div>
        <div class="section3-main">
          <custom-swiper></custom-swiper>
        </div>
      </div>
    </div>
    <div class="supplier-manage-section4">
      <div class="section4-content">
        <h1 class="section4-title">通过追求供应商管理改进实现的三大目标 :</h1>
        <div class="section4-divider"></div>
        <div class="section4-main">
          <div class="section4-choose">
            <ul class="section4-ul clearfix">
              <li class="section4-li fl" v-for="(item, index) in targetData" :key="index">
                <div class="detail">
                  <img class="detail-img" v-lazy="item.src" alt="通过追求供应商管理改进实现的三大目标">
                </div>
                <h2 class="detail-title">{{item.title}}</h2>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="supplier-manage-section5">
      <div class="section5-content">
        <h1 class="section5-title">客户案例</h1>
        <div class="section5-divider"></div>
        <div class="section5-main">
          <ul class="main-list clearfix">
            <li class="detail-content fl" v-for="(item, index) in caseData"
                :key="index">
              <img v-lazy="$global.globalPath + item.gongy_logo" alt="客户案例"/>
            </li>
          </ul>
          <p @click="this.goConsult">咨询案例详情 ></p>
        </div>
      </div>
    </div>
    <div class="supplier-manage-section6">
      <div class="section6-content">
        <h1 class="section6-title">客户感言</h1>
        <!--        <div class="section6-divider"></div>-->
        <!--        <div class="section6-main">-->
        <!--          <div class="section6-detail">-->
        <!--            <el-carousel indicator-position="none" arrow="always">-->
        <!--              <el-carousel-item v-for="item in speechData" :key="item.id">-->
        <!--                <div class="rel carousel-content">-->
        <!--                  <div class="abs carousel-img" v-if="item.img">-->
        <!--                    <img v-lazy="$global.globalPath + item.img">-->
        <!--                  </div>-->
        <!--                  <div class="abs carousel-desc">-->
        <!--                    <div class="carousel-desc-w">-->
        <!--                      <div class="tl ellipse title">{{item.source}}</div>-->
        <!--                      <div class="tl desc">-->
        <!--                        {{item.speech}}-->
        <!--                      </div>-->
        <!--                      <div class="tr company-name"> —{{item.name}}</div>-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--              </el-carousel-item>-->
        <!--            </el-carousel>-->
        <!--          </div>-->
        <!--        </div>-->
        <speech-swiper :mark="0"></speech-swiper>
      </div>
    </div>
  </div>
</template>
<script>
import hoverButton from '../common/hoverButton.vue'
import banner from '../common/banner.vue'
import customSwiper from '../common/swiper.vue'
import SpeechSwiper from '../common/speechSwiper.vue'

export default {
  inject: ['openRegister', 'goConsult'],
  name: 'Supplier',
  metaInfo () {
    return {
      title: this.$seo.supplier.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.supplier.keywords
      },
      {
        name: 'description',
        content: this.$seo.supplier.description
      }]
    }
  },
  components: {
    hoverButton,
    customSwiper,
    banner,
    SpeechSwiper
  },
  data () {
    return {
      speechData: [],
      mainData: [
        {
          title: '供应商信息管理',
          src: require('../../assets/img/supplier/icon-1.png')
        },
        {
          title: '供应商绩效管理',
          src: require('../../assets/img/supplier/icon-2.png')
        },
        {
          title: '公开招募与准入',
          src: require('../../assets/img/supplier/icon-3.png')
        },
        {
          title: '全面的数据情报',
          src: require('../../assets/img/supplier/icon-4.png')
        },
        {
          title: '主数据统一管理',
          src: require('../../assets/img/supplier/icon-5.png')
        },
        {
          title: '轻松注册与更新',
          src: require('../../assets/img/supplier/icon-6.png')
        }
      ],
      targetData: [
        {
          title: '规范化供应商引入过程',
          src: require('../../assets/img/supplier/1.svg')
        },
        {
          title: '数据化供应商信息，提升可用性',
          src: require('../../assets/img/supplier/2.svg')
        },
        {
          title: '客观公正，数据体现绩效',
          src: require('../../assets/img/supplier/3.svg')
        }
      ],
      caseData: []
    }
  },
  methods: {
    // 了解更多
    goMore (code) {
      this.openRegister(false, code)
    },
    // 客户案例
    getCaseData () {
      this.$api.post('/cases/get_cases', { webname: 'supplier', cases_sum: 10 }, (r) => {
        if (r.code === 0) {
          this.caseData = r.data
        } else {
          this.$message.error(r.message)
        }
      })
    }
    // 真实感言
    // getSpeechData () {
    //   this.$api.post('/index/home_speech', { mark: 0 }, (r) => {
    //     if (r.code === 0) {
    //       this.speechData = r.data
    //     } else {
    //       this.$message.error(r.message)
    //     }
    //   })
    // }
  },
  created () {
  },
  mounted () {
    this.getCaseData()
    // this.getSpeechData()
  }
}
</script>
<style lang="scss">
  @import "../../../static/css/supplier.scss";
</style>



// WEBPACK FOOTER //
// supplier.vue?4c0e59b8